import { Common, color, device } from '@stockbit/ui';
import styled from 'styled-components';

const { Text, Flex } = Common;

const AdditionalWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 50px;
  margin: auto;
  padding: 0 25px;
  width: 100%;
  max-width: 940px;

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 100px;
    padding: 0;
    width: calc(100% - 151px);
  }
`;

const Title = styled(Text).attrs({
  as: 'h2',
  size: '40px',
  family: 'bold',
})`
  text-align: center;
  margin: auto;
  margin-bottom: 20px;

  @media ${device.tablet} {
    text-align: left;
    margin: unset;
    margin-bottom: 20px;
  }
`;

const Description = styled(Text).attrs({
  height: 1.3,
  color: color.dimgray,
})`
  font-size: 16px;
  margin: auto;
  text-align: center;

  @media ${device.tablet} {
    margin: unset;
    text-align: left;
  }

  @media ${device.laptop} {
    font-size: 18px;
  }
`;

const HeaderWrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;
  margin: 100px auto;
  padding: 50px 25px;
  width: 100%;
  max-width: 1300px;

  .title-wrapper,
  .illustration {
    width: 100%;
  }

  .title-wrapper {
    margin-bottom: 70px;
  }

  @media ${device.tablet} {
    padding: 50px 30px;
  }

  @media ${device.laptop} {
    flex-direction: row;
    margin: 130px auto;
    padding: 50px 0;
    width: calc(100% - 151px);

    .title-wrapper,
    .illustration {
      margin-bottom: 0;
    }

    .title-wrapper {
      width: 40%;
      padding-right: 50px;
    }
    .illustration {
      width: 60%;
      padding-left: 50px;
    }
  }
`;

const ButtonInvest = styled(Flex).attrs({
  as: 'a',
  align: 'center',
  justify: 'center',
})`
  background: ${color.primary};
  border-radius: 4px;
  color: ${color.light};
  cursor: pointer;
  font-family: var(--bold-font);
  font-size: 18px;
  height: 50px;
  margin: auto;
  margin-bottom: 50px;
  padding: 0 20px;
  text-transform: uppercase;
  width: fit-content;
  max-width: 100%;

  &:hover {
    color: ${color.light};
  }

  @media ${device.laptop} {
    margin: 0;
    margin-bottom: 9vh;
  }
`;

const HeaderTitle = styled(Text).attrs({
  as: 'h1',
  family: 'bold',
  height: 1.3,
})`
  font-size: 30px;
  margin: auto;
  margin-bottom: 20px;
  text-align: center;

  @media ${device.tablet} {
    font-size: 60px;
    margin-bottom: 60px;
  }

  @media ${device.laptop} {
    margin: 0;
    margin-bottom: 60px;
    text-align: left;
  }
`;

export {
  AdditionalWrapper,
  Title,
  Description,
  ButtonInvest,
  HeaderWrapper,
  HeaderTitle,
};
